export default __webpack_public_path__ + "static/media/trivial.fdf62d31.png";